export default {
  data() {
    return {
      basicOperating: true,
      searchSchema: [
        {
          label: '企业名称',
          itemName: 'name',
          type: 'input',
          allowClear: true,
          placeholder: '请输入企业名称',
        },
        {
          label: '企业ID',
          itemName: 'code',
          type: 'input',
          allowClear: true,
          placeholder: '请输入企业ID',
        },
        {
          label: '信用主管',
          itemName: 'creditManager',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
        {
          label: '业务类型',
          itemName: 'business',
          type: 'select',
          selectList: [],
          handleChange: this.handleModelChange,
          allowClear: true,
        },
        {
          label: '业务模式',
          itemName: 'model',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
        {
          label: '客户状态',
          itemName: 'status',
          type: 'select',
          selectList: [
            {
              text: '正常客户',
              value: '1',
            },
            {
              text: '黑名单',
              value: '2',
            },
          ],
          allowClear: true,
        },
      ],
      searchData: {
        name: '',
        code: '',
        creditManager: '',
        business: '',
        model: '',
      },
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          align: 'center',
          slots: { title: 'customTitile' },
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
          // scopedSlots: { customRender: 'order'}
        },
        {
          title: '企业名称',
          dataIndex: 'name',
          width: 250,
        },
        {
          title: '企业ID',
          dataIndex: 'code',
          width: 150,
        },
        {
          title: '信用主管',
          dataIndex: 'creditManager',
          width: 150,
        },
        {
          title: 'Geo',
          dataIndex: 'Geo',
          width: 100,
        },
        {
          title: '业务类型',
          dataIndex: 'business',
          width: 120,
        },
        // {
        //   title: '大区/模式',
        //   dataIndex: 'region',
        //   width: 120,
        // },
        {
          title: '业务模式',
          align: 'center',
          dataIndex: 'model',
          width: 120,
        },
        {
          title: '信控区',
          dataIndex: 'creditArea',
          align: 'center',
        },
        {
          title: '成立年限',
          dataIndex: 'establishYear',
          align: 'center',
          width: 100,
        },
        {
          title: '合作年限',
          dataIndex: 'coopTime',
          align: 'center',
          width: 100,
        },
        {
          title: '客户状态',
          dataIndex: 'customerStatus',
          width: 150,
        },
        {
          title: '操作',
          fixed: 'right',
          width: 200,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
